module.exports = __webpack_public_path__ + "img/Lytton-Zulu.95489b3a.jpg";